export default __webpack_public_path__ + "static/media/accupix.e38a899f.png";